import request from '@/utils/request'

//从环境变量获取auth服务的路径
const VUE_APP_ROLE_PATH = process.env.VUE_APP_ROLE_PATH

//初始化state
const state = {
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    /**
     * @description 获取角色列表
     * @return {Promise}
     */
    // eslint-disable-next-line no-unused-vars
    async getRoleList({ commit }, query) {
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/role/list`;
        const result = await request.get(url, {params:query});
        //获取服务返回数据
        return result;
    },

    // 查询角色详细
    async getRole({ commit }, { roleId }) {
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/role/${roleId}`;
        const result = await request.get(url);
        //获取服务返回数据
        return result;
    },
    // 新增角色
    async addRole(state, data) {
        let url = `${VUE_APP_ROLE_PATH}/role`;
        const result = await request.post(url, data);
        return result;
    },
    // 修改角色
    async editRole(state, params) {
        let url = `${VUE_APP_ROLE_PATH}/role`;
        const result = await request.put(url, params);
        return result;
    },
    // 删除角色
    async deleteRole({ commit }, { roleId }){
        let url = `${VUE_APP_ROLE_PATH}/role/${roleId}`;
        const result = await request.delete(url);
        return result;
    },
    // 根据角色ID查询菜单下拉树结构
    async roleMenuTreeselect({ commit }, { roleId }){
        let url = `${VUE_APP_ROLE_PATH}/menu/roleMenuTreeselect/${roleId}`;
        const result = await request.get(url,{params:{enterprOnly:true}});
        return result;
    },
    // 查询菜单下拉树结构
    async treeselect(){
        let url = `/system/menu/treeselect`;
        const result = await request.get(url,{params:{enterprOnly:true}});
        return result;
    },
    /**
     * 查询部门下拉树结构
     */
    async deptTreeSelect({ commit }, { roleId }){
        let url = `${VUE_APP_ROLE_PATH}/role/deptTree/${roleId}`;
        const result = await request.get(url);
        return result;
    },
    /**
     * 角色数据权限
     */
    async dataScope({ commit }, data){
        let url = `${VUE_APP_ROLE_PATH}/role/dataScope`;
        const result = await request.put(url, data);
        return result;
    },
    /**
     * 通过roleIds查询角色
     * @param roleIds
     */
    async optionSelect({ commit }, {roleId}){
        let url = `${VUE_APP_ROLE_PATH}/role/optionselect?roleIds=${roleId}`;
        const result = await request.get(url);
        return result;
    },
    /**
     * 查询角色已授权用户列表
     */
    async allocatedUserList({ commit }, query){
        let url =`${VUE_APP_ROLE_PATH}/role/authUser/allocatedList`;
        const result = await request.get(url, {params:query});
        return result;
    },
    /**
     * 取消用户授权角色
     */
    async authUserCancel({ commit }, data) {
        let url = `${VUE_APP_ROLE_PATH}/role/authUser/cancel`;
        const result = await request.put(url, data);
        return result;
    },
    /**
     * 批量取消用户授权角色
     */
    async authUserCancelAll({ commit },data) {
        let url = `${VUE_APP_ROLE_PATH}/role/authUser/cancelAll`;
        return request({
            url,
            method: 'put',
            params: data
        });
    },
    /**
     * 查询角色未授权用户列表
     */
    async unallocatedUserList({ commit }, query){
        let url =`${VUE_APP_ROLE_PATH}/role/authUser/unallocatedList`;
        const result = await request.get(url, {params:query});
        return result;
    },
    /**
     * 授权用户选择
     */
    async authUserSelectAll({ commit }, data){
        let url = `${VUE_APP_ROLE_PATH}/role/authUser/selectAll`;
        const result = await request({
            url: '/system/role/authUser/selectAll',
            method: 'put',
            params: data
        });
        return result;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }